export default "__VITE_ASSET__3ca2cffe__"